import React from 'react';
import { employer } from '../../data/mockData';

const PAGE_TITLES = {
  dashboard: { title: 'Dashboard', sub: 'Payroll pipeline overview' },
  pipeline: { title: 'Pipeline Runner', sub: 'Monitor & execute processing steps' },
  employer: { title: 'Employer Config', sub: 'Earning codes, deductions & tax setup' },
  employees: { title: 'Employee Profiles', sub: 'All 8 employees for this pay period' },
  workbook: { title: 'Workbook Output', sub: 'Extractor V3 parsed results' },
  validation: { title: 'Validation Flags', sub: 'Pre-load rule check results' },
  loader: { title: 'API Loader Results', sub: 'PrimePay earnings & deductions load' },
  reconciliation: { title: 'Reconciliation Report', sub: 'Post-load comparison & audit' },
  audit: { title: 'Audit Log', sub: 'All API calls and pipeline events' },
};

export default function TopBar({ page }) {
  const info = PAGE_TITLES[page] || { title: page, sub: '' };
  return (
    <header className="topbar">
      <div className="topbar-title">
        <h1>{info.title}</h1>
        <div className="breadcrumb">{info.sub}</div>
      </div>
      <div className="topbar-actions">
        <span className="run-badge">
          Run: {employer.lastRunId.split('_').slice(1).join('_')}
        </span>
        <span style={{ fontSize: 12, color: 'var(--ink-3)' }}>
          Pay Period: {employer.payPeriodStart} → {employer.payPeriodEnd}
        </span>
      </div>
    </header>
  );
}
